import { render } from "./ListaContratacoesView.vue?vue&type=template&id=25dd22e4&scoped=true"
import script from "./ListaContratacoesView.vue?vue&type=script&lang=js"
export * from "./ListaContratacoesView.vue?vue&type=script&lang=js"

import "./ListaContratacoesView.vue?vue&type=style&index=0&id=25dd22e4&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25dd22e4"]])

export default __exports__